export default __webpack_public_path__ + "static/media/header.44cf477a.png";